import CryptoJS from 'crypto-js';
import { appConfig } from '../AppConfig';

// Key used for encryption and decryption
const HELPER_KEY = appConfig.STORAGE_HELPER_UTILITY_KEY;

/**
 * Sets an item in localStorage with optional encryption.
 * @param key - The key under which the value is stored.
 * @param value - The value to be stored.
 * @param encrypted - Whether the value should be encrypted.
 */
export const setEncryptLocalStorage = (key: string, value: string, encrypted: boolean) => {
    try {
        if (encrypted) {
            // Encrypt the value before storing
            const encryptedText = CryptoJS.AES.encrypt(value, HELPER_KEY).toString();
            localStorage.setItem(key, encryptedText);
        } else {
            // Store the value as is
            localStorage.setItem(key, value);
        }
    } catch (e) {
        console.error("Error in localStorage encryption method.", e);
        return;
    }
};

/**
 * Gets an item from localStorage with optional decryption.
 * @param key - The key under which the value is stored.
 * @param decrypted - Whether the value should be decrypted.
 * @returns The decrypted value or the raw value if not decrypted.
 */
export const getDecryptLocalStorage = (key: string, decrypted: boolean): string | null => {
    const item = localStorage.getItem(key);
    if (!item) return null;

    if (decrypted) {
        try {
            // Decrypt the value before returning
            const bytes = CryptoJS.AES.decrypt(item, HELPER_KEY);
            const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
            return decryptedText;
        } catch (e) {
            console.error("Error in localStorage decryption method.", e);
            return null;
        }
    }
    return item;
};